import Link from 'next/link';
import { RiArrowRightLine } from 'react-icons/ri';

import type { Category } from '@/shared/api/generated/api.generated';
import { pagesPath } from '@/shared/config/$path';

import { EquipmentImage } from './equipment-image';

const order = [
  '1e875ded-f8bc-490d-8389-bb3d07990250',
  '4fa9cbf3-ffd4-4647-8209-b62eb2923440',
  '8976e358-9ddb-42d7-a689-927353a3f08f',
  '1af56996-9eef-4d7a-80f3-ea03593039db',
  '9d69b166-1a39-4073-b952-d24432f89128',
];
const rank = (id: string) => (order.includes(id) ? order.indexOf(id) : order.length);
export const categoryName = (category: Category) => category.name;
export const CategoryGrid = ({
  categories,
  compact = false,
  imagery = 'catalog',
}: {
  categories: Category[];
  compact?: boolean;
  imagery?: 'catalog' | 'studio';
}) => (
  <div
    className={`category-grid${compact ? ' category-grid--compact' : ''}${
      imagery === 'studio' ? ' category-grid--studio' : ''
    }`}
  >
    {[...categories]
      .sort((a, b) => rank(a.id) - rank(b.id))
      .map((category, index) => (
        <Link
          key={category.id}
          className={`category-tile category-tile--${index + 1}`}
          href={
            category.children?.length
              ? pagesPath.catalog._categoryId(category.id).$url()
              : pagesPath.catalog._categoryId(category.id).products.$url()
          }
        >
          <span className="category-tile__number">0{index + 1} / НАПРАВЛЕНИЕ</span>
          <span className="category-tile__image">
            <EquipmentImage
              src={
                imagery === 'studio'
                  ? (category as Category & { homepageImage?: string }).homepageImage || category.image
                  : category.image
              }
              alt={category.name}
              fill
              sizes="(max-width: 700px) 90vw, 45vw"
            />
          </span>
          <span className="category-tile__bottom">
            <span>{categoryName(category)}</span>
            <RiArrowRightLine aria-hidden />
          </span>
        </Link>
      ))}
  </div>
);
